module.exports = __webpack_public_path__ + "img/task.a5ba8aa8.svg";